import { getApiActionTypesValues } from '../redux_utils';

export const fetchAvailableCitiesAndStates = () => async (dispatch) => {
  const data = await dispatch({
    types: getApiActionTypesValues('FETCH_CITIES_STATES'),
    promise: ({ client }) => client.get('/homes/available-locations'),
  });
  return data;
};
